import React from 'react';
import svgIcon from '../../../images/animate.svg';
import svgIconThumbnail from '../../../images/rostam.jpg';
import './Banner.css';

const Banner = () => {

    return (
        <>
            <section id="banner">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-12">
                            <div className="banner__text">
                                <h1 className="banner__title">
                                    Front-End <br /> 
                                    Developer.
                                </h1>
                                <p className="banner__subtitle">
                                    I like to craft solid and scalable frontend products with great user experiences.
                                </p>
                                <a className="banner__btn" href="#portfolio">SEE my work &rarr;</a>
                            </div>
                        </div>
                        <div className="col-md-6 col-12">
                            <div className="banner__thumbnail--wrapper">
                                <div className="banner__thumbnail">
                                    <img src={svgIcon} alt="" className="svg__icon" />
                                    <span style={{
                                        backgroundImage: `url(${svgIconThumbnail})`
                                    }} className="svg__icon--thumbnail"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Banner;